namespace TabAurous.Retail {
    export namespace POSSalesService {
        export const baseUrl = 'POSSales/POSSales';

        export declare function Create(request: Serenity.SaveRequest<POSSalesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<POSSalesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSSalesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Authorize(request: AuthorizationRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function POSInvoiceExportExcel(request: POSInvoicePrintRequest, onSuccess?: (response: Common.ExcelGenerateResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetLineNo(request: Serenity.ServiceRequest, onSuccess?: (response: Common.GetLineNoResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function TotalSalesList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "POSSales/POSSales/Create",
            Update = "POSSales/POSSales/Update",
            Delete = "POSSales/POSSales/Delete",
            Retrieve = "POSSales/POSSales/Retrieve",
            List = "POSSales/POSSales/List",
            Authorize = "POSSales/POSSales/Authorize",
            POSInvoiceExportExcel = "POSSales/POSSales/POSInvoiceExportExcel",
            GetLineNo = "POSSales/POSSales/GetLineNo",
            TotalSalesList = "POSSales/POSSales/TotalSalesList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'Authorize', 
            'POSInvoiceExportExcel', 
            'GetLineNo', 
            'TotalSalesList'
        ].forEach(x => {
            (<any>POSSalesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
